import styled from '@emotion/styled';

const AppContent = styled('main')({
  width: 900,
  maxWidth: '100%',
});

export default AppContent;
